import React from 'react';
import {
  Box,
  CircularProgress,
  Slide,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Typography,
} from '@mui/material';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export const CustomDialog = ({
  isOpen,
  handleClose,
  title,
  contents,
  buttons,
  size,
  backdropStyle,
  zIndex,
  loading,
  loadText,
  publish,
  removeTitle,
  removeButtons,
  dialogClassName,
}) => {
  const paperSx = {
    bgcolor: 'background.paper',
    color: 'text.primary',
  };

  if (!loading) {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={size ? size : 'sm'}
        className={`${publish ? 'dialogWithBackdrop' : ''} ${dialogClassName || ''}`}
        BackdropProps={{
          classes: {
            root: backdropStyle ? backdropStyle : '',
          },
        }}
        PaperProps={{ sx: paperSx }}
        style={zIndex ? { zIndex: zIndex } : { zIndex: 1300 }}
        open={isOpen ? isOpen : false}
        TransitionComponent={Transition}
        onClose={handleClose}
        disableEnforceFocus={true}
      >
        {!removeTitle && (
          <DialogTitle component="div" sx={{ color: 'text.primary' }}>
            {typeof title === 'string' ? (
              <Typography variant="h6" component="h5" sx={{ fontWeight: 600 }}>
                {title}
              </Typography>
            ) : (
              title
            )}
          </DialogTitle>
        )}
        <DialogContent>{contents}</DialogContent>
        {!removeButtons && <DialogActions>{buttons}</DialogActions>}
      </Dialog>
    );
  } else {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={size ? size : 'sm'}
        style={zIndex ? { zIndex: 100000 } : { zIndex: 1000 }}
        BackdropProps={{
          classes: {
            root: backdropStyle ? backdropStyle : '',
          },
        }}
        PaperProps={{ sx: paperSx }}
        open={isOpen ? isOpen : false}
        TransitionComponent={Transition}
        onClose={handleClose}
        disableEnforceFocus={true}
      >
        <DialogContent>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              py: 4,
            }}
          >
            <CircularProgress size={40} />
            {loadText && (
              <Typography
                variant="body2"
                sx={{ mt: 2, textAlign: 'center', whiteSpace: 'pre-line', color: 'text.secondary' }}
              >
                {loadText}
              </Typography>
            )}
          </Box>
        </DialogContent>
      </Dialog>
    );
  }
};
